import { Field } from 'formik';

export const SingleInputFormik = ({
  label,
  name,
  component: Component,
  readOnly = false,
  required = false,
}) => {
  return (
    <Field name={name}>
      {({ field, form, meta }) => {
        return (
          <Component
            value={field.value}
            onChange={newName => {
              form.setFieldValue(name, newName);
            }}
            label={label}
            name={field.name}
            onBlur={form.handleBlur(name)}
            onSubmitEditing={form.handleSubmit}
            error={meta.touched && meta.error}
            style={{ flex: 0 }}
            readOnly={readOnly || form.isSubmitting}
            required={required}
          />
        );
      }}
    </Field>
  );
};
